import React, {useEffect, useState} from "react";
import {deleteResource, getByIdResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import DeleteModal from "../../ui/DeleteModal";
import Delete from '../../../assets/img/profile-images/Izbrisi-icon.png';
import {GenericEditModalForm} from "./GenericEditModalForm";

export const ProfileSkillSegment = ({candidate, isPreview}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [updateSkills, setUpdateSkills] = useState(false)

    const [entity, setEntity] = useState({candidate: candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)


    const getCandidateExistingList = () => {
        getByIdResource('candidate_skills/get_by_candidate', candidate.id).then((data) => {
            setCandidateExistingList(data.data);
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
        })
    }
    const confirmDelete = (data, url, refreshEntity, setRefreshEntity) => {
        deleteResource(url, data).then(() =>{
            setRefreshEntity(!refreshEntity);
        }).catch((error) => {
            console.log('error')
        })
    }

    useEffect(()=> {
        getCandidateExistingList();
    },[])

    useEffect(() => {
        getByIdResource('candidate_skills/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
            getCandidateExistingList();
        })
    }, [updateEntity, updateSkills])



    return(
        <div className='profile_segment_main_container'>
            {(candidateExistingList && candidateExistingList.length > 0) &&
                candidateExistingList.map(entity => <>
                    <div className='profile_segment_separate_info d-flex justify-content-between' key={entity.id}>
                        <div>
                            {entity.otherSkill ? <li>{entity.otherSkill}</li> : entity.skill ?
                                <li key={entity.id}>{entity.skill.name}</li> : null}
                        </div>
                        <div className="icons-div justify-self-end">
                           {!isPreview && <div className="edit_delete_icons">
                               <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                                   confirmDelete(entity, 'candidate_skills', updateSkills, setUpdateSkills)}/>
                           </div>}
                       </div>
                     </div>
                    {!isPreview &&  <hr/>}
                    </>
                )}

            {!isPreview && !addEntity && (<div className="profile_add_button mt-3"
                                               onClick={() =>
                                               {setEntity({...entity, candidate: candidate})
                                                   setAddEntity(true)}}
            >Додади вештина</div>)}
            {addEntity === true && (<div className="open-form"> <GenericEditModalForm
                type="SKILL"
                title= {"Додади вештина"}
                entity={entity} setEntity={setEntity}
                addEntity={addEntity} setAddEntity={setAddEntity}
                updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}/></div>)}
            {!resultListEmpty && <hr/>}
        </div>
    )
}